import * as types from '../mutation-types'

const state = {
    main: {
        id: 0,
        userData: [],
        role: 0,
        roleSlug: '',
        token: 0,
        isLoginSuper: false,
        clientId: '', //'bb7fddf0-6a0f-11e7-b301-3f66590aa632',
        clientUserId: '',
        clientName: '',
        userName: '',
        firstName: '',
        lastName: '',
        userFullName: '',
        employeeId: '',
        loggedInEmployeeId: '',
        userImage: '',
        userPhone: '',
        actionLogType: '',
        editEmployeesFrom: '',
        signInSheetConfig: {},
        signInPageBrokenStatus: '',
        userNotificationType: '',
        wishListType: '',
        jobFilter: {
            parent: 'Alljob',
            child: 'day'
        },
        subdomain: '',
        companyId: '',
        employerUserId: '',
        getOpenJob: 0,
        currency: 'usd',
        email: '',
        gcs_signin_sheet_template: '',
        edit_user_tab: '',
        user_language: '',
        nylas_user_email: '',
        token_expiry: '',
        is_billing_employee: false,
        query_param_client_id: '', 
        query_param_app_source: false
    }

}
const getters = {
    userID: state => state.main.id,
    userToken: state => state.main.token,
    userRole: state => state.main.role,
    userName: state => state.main.userName,
    firstName: state => state.main.firstName,
    employeeId: state => state.main.employeeId,
    loggedInEmployeeId: state => state.main.loggedInEmployeeId,
    userRoleSlug: state => state.main.roleSlug,
    userLanguage: state => state.main.user_language,
    edit_user_tab: state => state.main.edit_user_tab,
    getNylasUserEmail: state => state.main.nylas_user_email,
    getTokenExpiry: state => state.main.token_expiry,
    isBillingEmployee: state => state.main.is_billing_employee,
    query_param_client_id: state => state.main.query_param_client_id,
    query_param_app_source: state => state.main.query_param_app_source
}
const actions = {
    userSession({ commit, state }, data) {
        commit(types.USER_DATA_CHANGE, data)
    },
    setEmployeeId({commit},id) {
        commit(types.SET_EMPLOYEE_ID, id)
    },
    onSwitchClient({ commit, state }, data) {
        // console.log('action', data);
        commit(types.SET_SWITCH_CLIENT, data);
    },
    setActionTypeForLog({ commit, state }, data) {
        commit(types.SET_ACTION_FOR_LOG, data);
    },
    setEditEmployeesFrom({ commit, state }, data) {
        commit(types.SET_EDIT_EMPLOYEE_FROM, data);
    },
    setClientdata({ commit, state }, data) {
        commit(types.SET_CLIENT_DATA, data);
    },
    setNotificationType({ commit, state }, data) {
        commit(types.SET_NOTYFICATION_TYPE, data);
    },
    setWishListType({ commit, state }, data) {
        commit(types.SET_WISH_LIST_TYPE, data);
    },
    setSelectedJobFilter({ commit, state }, data) {
        commit(types.SET_SELECTED_JOB_FILTER, data);
    },
    setLastOpenJob({ commit, state }, data) {
        commit('setLastOpenJob', data);
    },
    setUserImage({ commit, state }, data) {
        commit(types.SET_USER_IMAGE, data)
    },
    setLoginSuper({ commit, state }, data) {
        commit(types.IS_LOGIN_SUPER, data)
    },
    setEditUserTab({ commit }, data) {
        commit(types.SET_EDIT_USER_TAB, data)
    },
    setNylasUserEmail({ commit }, email) {
        commit(types.SET_NYLAS_USER_EMAIL, email)
    },
    setTokenExpiry({ commit }, dateTime) {
        commit(types.SET_TOKEN_EXPIRY, dateTime)
    },
    
    setIsBillingEmployee({commit}, status) {
        commit(types.SET_IS_BILLING_EMPLOYEE, status)
    },
    setQueryParamClientId({commit}, clientId) {
        commit(types.SET_QUERY_PARAM_CLIENT_ID, clientId)
    },
    setQueryParamAppSource({ commit }, app_source) {
        commit(types.SET_QUERY_PARAM_APP_SOURCE, app_source)
    }
}

const mutations = {
    [types.USER_DATA_CHANGE](state, data) {
        // console.log(data);
        state.main.userData = data;
        state.main.id = data.user.id;
        state.main.user_language = data.user.language;
        state.main.token = data.token;
        state.main.role = data.role.id;
        state.main.roleSlug = data.role.slug;

        // console.log('USER_DATA_CHANGE 1');
        // console.log(data.user.language);
        if (data.role.slug == "client-admin" || data.role.slug == "employee" || data.role.slug == "power-user") {
            if (data.user) {
                state.main.userName = data.user.display_name;
                state.main.firstName = data.user.first_name;
                state.main.lastName = data.user.last_name;
                state.main.userFullName = data.user.first_name + " " + data.user.last_name;
                state.main.employeeId = data.user.employees[0].id;
                state.main.loggedInEmployeeId = data.user.employees[0].id;
                state.main.userImage = data.user.image;
                state.main.userPhone = data.user.phones;
                state.main.email = data.user.email;
                state.main.user_language = data.user.language
            }
            // console.log('USER_DATA_CHANGE 2');
            if (data.user && data.user.employees && data.user.employees.length && data.user.employees[0].client_employee && data.user.employees[0].client_employee.clients) {
                // console.log('USER_DATA_CHANGE 3');
                state.main.clientId = data.user.employees[0].client_employee.clients.id;
                state.main.clientName = data.user.employees[0].client_employee.clients.contact_person;
                state.main.clientUserId = data.user.employees[0].client_employee.clients.user_id;
                state.main.subdomain = data.user.employees[0].client_employee.clients.subdomain;
                state.main.currency = data.user.employees[0].client_employee.clients.currency;
            }
        } else if (data.role.slug == "employer-admin" || data.role.slug == "employer") {
            state.main.userName = data.user.display_name;
            state.main.firstName = data.user.first_name;
            state.main.lastName = data.user.last_name;
            state.main.userFullName = data.user.first_name + ' ' + data.user.last_name;
            state.main.userImage = data.user.image;
            state.main.userPhone = data.user.phones;
            state.main.email = data.user.email;
            state.main.user_language = data.user.language

            state.main.companyId = data.user.employer_users[0].employer.id;
            state.main.employerUserId = data.user.employer_users[0].id;

            state.main.clientId = '';
            state.main.clientName = '';
            state.main.clientUserId = '';
            state.main.subdomain = '';
            state.main.employeeId = '';
            state.main.loggedInEmployeeId = '';
            state.main.getOpenJob = 0;
        }
    },

    [types.SET_SWITCH_CLIENT](state, data) {
        state.main.userData = data;
        state.main.role = data.role.id;
        state.main.roleSlug = data.role.slug;
        // console.log(data);
        if (data.role.slug == "client-admin" || data.role.slug == "employee" || data.role.slug == "power-user" || data.role.slug == "auditor") {
            state.main.userName = data.user.display_name;
            state.main.firstName = data.user.first_name;
            state.main.lastName = data.user.last_name;
            state.main.userFullName = data.user.first_name + ", " + data.user.last_name;
            state.main.employeeId = data.user.employees[0].id;
            state.main.loggedInEmployeeId = data.user.employees[0].id;

            state.main.userImage = data.user.image;
            state.main.userPhone = data.user.phones;

            state.main.clientId = data.user.employees[0].client_employee.clients.id;
            state.main.clientName = data.user.employees[0].client_employee.clients.contact_person;
            state.main.clientUserId = data.user.employees[0].client_employee.clients.user_id;
            state.main.subdomain = data.user.employees[0].client_employee.clients.subdomain;
        }
    },

    [types.SET_EMPLOYEE_ID](state,id) {
        state.main.employeeId = id;
    },
    [types.SET_ACTION_FOR_LOG](state, data) {
        state.main.actionLogType = data;
    },

    [types.SET_EDIT_EMPLOYEE_FROM](state, data) {
        state.main.editEmployeesFrom = data;
    },

    [types.SET_CLIENT_DATA](state, data) {
        if (data && data.settings) {
            state.main.signInSheetConfig = {
                'sign-in-sheet': data.settings['sign-in-sheet'],
                'call-data-config': data.settings['call-data-config'],
                'job-info-config': data.settings['job-info-config'],
            };
            state.main.signInPageBrokenStatus = data.page_breakdown;
            state.main.gcs_signin_sheet_template = data.gcs_signin_sheet_template;
        }
    },

    [types.SET_NOTYFICATION_TYPE](state, data) {
        state.main.userNotificationType = data;
        //console.log(data);
    },
    [types.SET_WISH_LIST_TYPE](state, data) {
        state.main.wishListType = data;
        //console.log(data);
    },
    [types.SET_SELECTED_JOB_FILTER](state, data) {
        state.main.jobFilter = data;
        //console.log(data);
    },
    [types.SET_USER_IMAGE](state, data) {
        state.main.userImage = data;
    },

    [types.IS_LOGIN_SUPER](state, value) {
        state.main.isLoginSuper = value;
    },
    [types.SET_EDIT_USER_TAB](state, value) {
        state.main.edit_user_tab = value;
    },

    setLastOpenJob(state, data) {
        state.main.getOpenJob = data;
        //console.log(data);
    },

    [types.SET_NYLAS_USER_EMAIL](state, email) {
        state.main.nylas_user_email = email;
    },

    [types.SET_TOKEN_EXPIRY](state,dateTime) {
        state.main.token_expiry = dateTime;
    },

    [types.SET_IS_BILLING_EMPLOYEE](state,status) {
        state.main.is_billing_employee = status;
    },
    [types.SET_QUERY_PARAM_CLIENT_ID](state, client_id) {
        state.main.query_param_client_id = client_id;
    },
    [types.SET_QUERY_PARAM_APP_SOURCE](state, app_source) {
        state.main.query_param_app_source = app_source;
    },
    

}

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js